import React from "react";
import { Badge } from "../../../ui/badge";

export default function KPICard({ title, value, subtitle, icon, trend, trendValue, className = "" }) {
  return (
    <div
      className={`bg-white dark:bg-[#0C0E12] border border-gray-200 dark:border-[#22262F] rounded-lg p-5 ${className}`}
    >
      <div className="flex items-start gap-4">
        {icon && (
          <div className="w-10 h-10  rounded-lg flex items-center justify-center shrink-0 ">{icon}</div>
        )}
        <div>
          <p className="text-sm font-semibold text-[#535862] dark:text-[#94979C]">{title}</p>
          <div className="mt-2 space-y-1">
            <div className="text-3xl font-semibold text-[#181D27] dark:text-white">{value}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
